import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';



import { ApiPartnerService } from '../../api/api-partner.service';


@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css']
})
export class PurchaseComponent implements OnInit {

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    ) { }

  msearch : string;
  customer:any;
  products:any;
  summary : any = {customer:{},product:{}};

  productselected:number = null;
  productcode:string;
  producttype;

  customerselected:number = null;
  customercode:string;
  successConfirm = false;


  error = false;
  result = false;
  formOpen = false;
  errMsg : string;

  loadingbuy = false;
  loadingbill = false;
  buttonbuydisable = true;
  radioService : number;
  radioCustomer : number;

  outstanding = [];
  isoutstanding = false;
  totaloutstanding = 0;
  grandtotal = 0;
  confirmbuy = [];
  customerid : string;
  showformsearch = false;

  ngOnInit() {
    window.location.href = 'https://purchase.visionplustv.id';
    return;
    this.customerid = this.route.snapshot.paramMap.get('id');
    if ( this.customerid ){
      this.loadSearch({search:this.customerid});

    }else{
      this.showformsearch = true;
    }
    
  }

  pickproduct(i)
  {
    this.productselected = i;
    console.log(i);
    console.log(this.products[i]);
    this.radioService = this.products[i]['id'];
    this.summary.product = this.products[i];
    if ( this.customerselected != null && this.productselected != null ){
      this.buttonbuydisable = false;
    }

    if ( this.isoutstanding ){
      this.grandtotal = this.totaloutstanding + this.products[i]['price'];
    }


  }

  selected(i)
  {
    if (i == this.productselected){
      return 'list-group-item-action list-group-item-primary';
    }else{
      return '';
    }
  }

  pickcustomer(i)
  {
    
    //console.log(i);
    //console.log(this.customer[i]);  
    if ( this.customer[i]['is_isp'] == 1 ){
      
      alert('Anda tidak dapat memilih ID Pelanggan ini');

    }else{
      this.customerselected = i;
      this.radioCustomer = this.customer[i]['customerid'];
      this.summary.customer = this.customer[i];
      if ( this.customerselected != null && this.productselected != null ){
        this.buttonbuydisable = false;
      }

      this.loadOutstanding(this.customer[i]['customerid']);
    }
  }

  selectedcustomer(i)
  {
    if (i == this.customerselected){
      return 'list-group-item-action list-group-item-success';
    }else{
      return '';
    }
  }

  search()
  {
    //alert(this.msearch);
    //this.searchQueryParams = this.queryParams+'&search='+params;
    this.successConfirm = false;
    
    this.outstanding = [];
    this.isoutstanding = false;
    this.totaloutstanding = 0;
    this.grandtotal = 0;
    this.loadingbuy = false;
    
    this.loadSearch({search:this.msearch});
    this.customerselected = null;
    this.productselected = null;
    this.summary = {customer:{},product:{}};
    this.radioCustomer = null;
    this.radioService = null;
    
  }


  // Issues list
  loadSearch(params: any) {
    return this.partnerService.GetWPSearch(params).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        this.customer = output.data;
        console.log(this.customer[0]);

        this.error = false;
        this.formOpen = true;
        this.producttype = 3;
        this.loadProd({'producttype':3});
        
        if ( this.customer[0]['customerid'] == this.customerid ){
          this.pickcustomer(0);
        }

      }else{
       this.error = true;
       this.formOpen = false;
       this.errMsg = output.message;
      }
    })
  }

  
  loadProd(params: any) {
    return this.partnerService.GetWPProdaddon(params).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        this.products = output.data;
        //this.error = false;
        //this.result = true;
      }else{
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
    })
  }

  loadOutstanding(params: any) {
    return this.partnerService.GetWPOutstanding(params).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        this.isoutstanding = true;
        this.outstanding = output.paket;
        this.totaloutstanding = output.totaloutstanding;
        console.log(this.outstanding);
      }else{
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
    })
  }

 
  
  buydisabled()
  {
    return (!this.isCustomerSelected() || !this.isProductSelected());
    //return  this.buttonbuydisable;
  }

  buy()
  {
  
    this.loadingbuy = true;
    this.buttonbuydisable = true;
    // checkout
    let selected = this.products[this.productselected];
    let mycustomer = this.customer[this.customerselected];
    this.summary = {customer:mycustomer,product:selected};
    let data = {"ID":selected['productcode'],"CID":mycustomer['customerid']};
    console.log(data);
    console.log(this.summary);
/*
    setTimeout(() => {  
        this.successConfirm = true;
        this.formOpen = false; }, 
    2000);

    return;
*/
    this.confirmbuy = [];
    return this.partnerService.PostWPCheckout(data).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        
        this.confirmbuy = output.data;

        let params = {customer_id:output.data['account_id'],paketname:output.data['paketname'],sn:output.data['sn'],price:output.data['price'], nohp:output.data['nohp']};

        this.WaNotif(params);

      }else{
       this.successConfirm = false; 
       alert(output.data.message);

       this.loadingbuy = false;
       this.buttonbuydisable = false;
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
    })
  }

  onSubmit()
  {
    var data = new FormData();
  data.append("app_id", "ATV");
  data.append("localdatetime", "20200411204100");
  data.append("product_id", "50100");
  data.append("customer_id", "1000000665");
  data.append("signature", "4849d1ec62a4d0891bae574e4dd9ef0250d12752");

  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;

  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === 4) {
      console.log(this.responseText);
    }
  });

  xhr.open("POST", "https://billing.mncplay.id/main/billinfo");
  xhr.setRequestHeader("Content-Type", "application/xhtml+xml");
  xhr.setRequestHeader("cache-control", "no-cache");
  xhr.setRequestHeader("Postman-Token", "16256e72-69a2-4e0e-b78c-d42969ed3283");

  xhr.send(data);
  }

  isCustomerSelected(){
    if ( this.customerselected == null ){
      return false;
    }else{
      return true;
    }
  }

  isProductSelected(){
    if ( this.productselected == null ){
      return false;
    }else{
      return true;
    }
  }

  nextBill()
  {
    this.loadingbill = true;
    window.location.href = 'https://b2b-api.mncplay.id/billmain.php?CID='+this.summary.customer.customerid;
  }

  WaNotif(params)
  {
    return this.partnerService.PostWPWaNotif(params).subscribe((output: any) => {
      console.log(output);
      this.successConfirm = true;
        this.formOpen = false;


    },error=>{
      //alert('error');
      this.successConfirm = true;
        this.formOpen = false;
    });

  }
  
  pickpaket(id){
    this.producttype = id;
    this.productselected = null;
    this.summary.product = {};
    this.loadProd({'producttype': id});
  }
}
